import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";

import { DEFAULT_LOCALE, isSupportedLocale } from "./config";

/**
 * RedirectToDetectedLocale — lang プレフィックスのない URL を検出言語へ振り分ける。
 *
 * `/` 直アクセスや `/some/path` (lang セグメント抜け) は i18n 検出結果を採用。
 * 検出値が SUPPORTED_LOCALES に含まれない場合は DEFAULT_LOCALE (= ja) を採用する。
 */
export function RedirectToDetectedLocale() {
  const { i18n } = useTranslation();
  const location = useLocation();

  const detected = i18n.resolvedLanguage ?? i18n.language;
  const target = isSupportedLocale(detected) ? detected : DEFAULT_LOCALE;

  const suffix = location.pathname === "/" ? "" : location.pathname;
  return <Navigate to={`/${target}${suffix}${location.search}`} replace />;
}
